import createRoute from '@widesk-ui/tools/createRoute';
import ExportModel from '@models/shop/ExportModel';

export default createRoute.dashboard('/exports', 'shop', 'ExportDashboard', ExportModel.localize());